module.exports = __webpack_public_path__ + "media/images/navbar-logo-cab6eb726033809a65f937fc281d3046.webp";